import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
import { translate } from '@haldor/ui';
import { connect } from "react-redux";
import Moment from "moment";
import Modal from 'containers/Modals/Modal';
import { getActiveSchool } from 'helpers/localstorage';
import { Flex, Skeleton, Menu, Icon, TooltipMenu, Button, getActiveLanguage } from '@haldor/ui';
import { DataList, Spinner } from 'UI';
import { Trash } from 'UI/Icons';
import RowItem, { RowCell } from 'UI/Elements/List/RowItem';
import { getTeacherRoles, deleteTeacherRole, addTeacherRole } from 'actions/user';
import TeacherRoleForm from 'containers/Forms/TeacherRole';
import User from '_class/User';
import './Subjects.scss';

var Subjects = /*#__PURE__*/function (_Component) {
  _inherits(Subjects, _Component);

  var _super = _createSuper(Subjects);

  function Subjects(props) {
    var _this;

    _classCallCheck(this, Subjects);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.props.getTeacherRoles(_this.props.userId).then(function () {
        _this.setState({
          loading: false
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleModal", function () {
      _this.setState({
        modal: !_this.state.modal
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderSubjectRoleRow", function (teacherRole) {
      var removing = false;

      if (_this.state.removing != null && _this.state.removing == teacherRole.subjectCode) {
        removing = true;
      }

      var user = new User(_this.props.currentUser);
      return /*#__PURE__*/React.createElement(RowItem, {
        key: teacherRole.subjectCode
      }, /*#__PURE__*/React.createElement(RowCell, {
        title: _this.props.translate('name')
      }, removing ? /*#__PURE__*/React.createElement(Skeleton, null) : teacherRole.title), /*#__PURE__*/React.createElement(RowCell, {
        title: _this.props.translate('school')
      }, removing ? /*#__PURE__*/React.createElement(Skeleton, null) : _this.props.translate(teacherRole.typeOfSchooling)), user.isAdministrator() ? /*#__PURE__*/React.createElement(RowCell, {
        shrink: true,
        title: " "
      }, !removing ? /*#__PURE__*/React.createElement("div", {
        className: "icon"
      }, /*#__PURE__*/React.createElement("span", {
        className: "action",
        onClick: function onClick() {
          _this.onStudentTeacherDelete(teacherRole.subjectId);
        }
      }, /*#__PURE__*/React.createElement(Trash, {
        heigth: '22px'
      }))) : null) : null);
    });

    _defineProperty(_assertThisInitialized(_this), "onTeacherRoleSubmit", function (subjects) {
      var promises = [];
      var activeSchool = getActiveSchool(_this.props.currentUser.id);
      subjects.forEach(function (subject) {
        var subjectTeacher = {
          UserId: _this.props.currentStaff.id,
          SubjectId: subject.id,
          SubjectCode: subject.subjectCode,
          typeOfSchooling: subject.typeOfSchooling,
          Title: subject.title,
          SchoolId: activeSchool
        };
        promises.push(_this.props.addTeacherRole(_this.props.userId, subjectTeacher));
      });
      Promise.all(promises).then(function () {
        _this.toggleModal();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onStudentTeacherDelete", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(subjectId) {
        var activeSchool;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.setState({
                  removing: subjectId
                });

                activeSchool = getActiveSchool(_this.props.currentUser.id);
                _context.next = 4;
                return _this.props.deleteTeacherRole(_this.props.userId, subjectId, activeSchool);

              case 4:
                _context.next = 6;
                return _this.props.getTeacherRoles(_this.props.currentStaff.id, true);

              case 6:
                _this.setState({
                  removing: null
                });

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    Moment.locale(getActiveLanguage());
    _this.state = {
      loading: true,
      removing: null,
      modal: false,
      teacherRoles: []
    };
    return _this;
  }

  _createClass(Subjects, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var user = new User(this.props.currentUser);

      if (this.state.loading) {
        return /*#__PURE__*/React.createElement("div", {
          className: "temp-subject-administration"
        }, /*#__PURE__*/React.createElement("div", {
          className: "single-section"
        }, /*#__PURE__*/React.createElement(Spinner, {
          center: true
        })));
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "single-section"
      }, /*#__PURE__*/React.createElement(Modal, {
        onClose: this.toggleModal,
        title: this.props.translate('add-subject'),
        isOpen: this.state.modal,
        type: "small"
      }, /*#__PURE__*/React.createElement(TeacherRoleForm, {
        previousTeacherRoles: this.props.teacherRoles,
        onTeacherRoleSubmit: this.onTeacherRoleSubmit
      })), /*#__PURE__*/React.createElement(DataList, {
        data: this.props.teacherRoles,
        renderRow: this.renderSubjectRoleRow,
        emptyData: function emptyData() {
          return /*#__PURE__*/React.createElement("h3", {
            style: {
              textAlign: 'center'
            }
          }, _this2.props.translate('no-results'));
        }
      }), user.isAdministrator() ? /*#__PURE__*/React.createElement(Button, {
        style: {
          marginTop: '20px',
          "float": 'right'
        },
        type: "secondary",
        onClick: function onClick() {
          return _this2.toggleModal();
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Plus"
      }), " ", this.props.translate("Add")) : null);
    }
  }]);

  return Subjects;
}(Component);

function mapStateToProps(state, ownProps) {
  return {
    languages: state.Languages.languages,
    translate: translate(state.Languages.translations),
    tenant: state.user.tenant,
    currentUser: state.user.currentUser,
    teacherRoles: state.user.teacherRoles,
    currentStaff: state.user.info.find(function (u) {
      return u.userId == ownProps.userId;
    })
  };
}

export default connect(mapStateToProps, {
  getTeacherRoles: getTeacherRoles,
  deleteTeacherRole: deleteTeacherRole,
  addTeacherRole: addTeacherRole
})(Subjects);